import { render, staticRenderFns } from "./SegmentOfferDetails.vue?vue&type=template&id=5184e6f0"
import script from "./SegmentOfferDetails.vue?vue&type=script&lang=ts"
export * from "./SegmentOfferDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports